<template>
  <BaseVeeForm
    :action="deleteProjectAsset"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
  >
    <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="isPending">
      <div class="mx-auto w-full max-w-lg">
        <BaseCard>
          <BaseCardBody>
            <div class="space-y-1 mb-8">
              <h3 class="text-lg leading-6 font-medium text-gray-900">Delete project asset</h3>
              <p class="max-w-2xl text-sm text-gray-500">Permanently delete this project asset.</p>
            </div>
            <ValidationProvider :rules="{ required: { allowFalse: false } }" name="confirmed" slim>
              <template #default="{ errors }">
                <BaseFormGroup>
                  <div class="flex items-baseline">
                    <BaseFormCheckbox v-model="confirmed" :disabled="isPending" />
                    <p class="inline-block ml-2 measure">
                      I understand that by deleting this product reaction, all of its resources and
                      data will be permanently deleted.
                    </p>
                  </div>
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton v-if="!errorMessage" primary :disabled="isPending || invalid">
                Delete
              </BaseButton>
              <span v-else>{{ errorMessage }}</span>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      confirmed: false,
      errorMessage: '',
    };
  },
  methods: {
    async deleteProjectAsset() {
      try {
        await this.action(this.projectAsset.id);

        this.$emit('project-asset-deleted', this.projectAsset);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        if (error?.response?.status === 403) {
          this.errorMessage =
            'You cannot delete this Project asset. It has either Mailed approval requests or has been approved and not rejected yet';
        }
        return Promise.reject(error);
      }
    },
  },
};
</script>
